import React, { useState, memo, useEffect } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

toast.configure();
export const AvailableCorporationInsuranceFilters = memo((props) => {
  const { acceptance_result_id, insurances, using_insurance_ids } = props;
  // 初期設定
  const [usingInsuranceIds, setUsingInsuranceIds] = useState([]);
  useEffect(() => {
    setUsingInsuranceIds(using_insurance_ids);
  }, [])

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeInsurance = (event) => {
    const { value } = event.target;
    setUsingInsuranceIds(value);
  };

  const displayNames = (selected) => {
    var dispName = [];
    selected.map(selected_value => {
      insurances.map((insurance) => {
        if (insurance.id === selected_value) {
          dispName.push(insurance.name);
        }
      })
    })
    return dispName.join(', ');
  }

  const onClickInsurancesSubmit = () => {
    var data = { result_insurances: { insurance_ids: usingInsuranceIds }};

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/api/v1/acceptance_results/${acceptance_result_id}/result_insurances`, data)
    .then(resp => {
      console.log(resp.data);
      setUsingInsuranceIds(resp.data);
      notify("success", "CorporationInsurance successfully created!");
    })
    .catch(e => {
      console.log("api ng");
      console.log(e.response);
      setUsingInsuranceIds(using_insurance_ids);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "CorporationInsurance create Error!");
    })
  }

  return (
    <>
      <div className="input-group">
        <FormControl sx={{ mr: 1, width: 300 }} size="small">
          <InputLabel id="multiple-checkbox-label">健保</InputLabel>
          <Select
            labelId="multiple-checkbox-label"
            id="multiple-checkbox"
            multiple
            value={usingInsuranceIds}
            onChange={onChangeInsurance}
            input={<OutlinedInput label="健保" />}
            renderValue={(selected) => displayNames(selected)}
          >
            {insurances.map((insurance) => (
              <MenuItem key={insurance.id} value={insurance.id}>
                <Checkbox checked={usingInsuranceIds.indexOf(insurance.id) > -1} />
                <ListItemText primary={insurance.name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <button
          onClick={onClickInsurancesSubmit}
          className='btn btn-primary' 
          title="健保"
        >
          <i className='fas fa-filter' />
        </button>
      </div>
    </>
  );
});
